import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {PaymentChargeLinkData} from "./account-charge-link.data";

/**
 * Search model for Account Charges that still require payments
 */
@Injectable()
export class AccountPaymentChargeLinkSearchModel extends SearchModel<PaymentChargeLinkData> {

    constructor(injector: Injector) {
        super(injector, PaymentChargeLinkData);
    }

    override getIdentifierField(): string {
        return "linkId";
    }


    override isEntityLocalisable(): boolean {
        return false;
    }
}
